// LocationStatus.jsx
import { MapPinIcon } from 'lucide-react';

export default function LocationStatus({ verified }) {
  return (
    <div className="flex items-center text-sm text-gray-600 mt-4">
      <MapPinIcon className="h-5 w-5 mr-2 text-amber-500" />
      <span>Office Location {verified ? '(Verified)' : '(Unverified)'}</span>
    </div>
  );
}
